export default "__VITE_ASSET__dbd033ab__"